
import { MUTUAL_FUNDS } from "../actionTypes";


const initialState = {
    mutualFund: [],
    filters: [],
    holdings: [],
    mutualFundTypes: [],
    nfo: [],
    orders: [],
    themes: [],
    watchList: {
        data: [],
        name: "",
        mutualFundProfile: {}
    },

    fundOverview: [],
    portfolioSumaary: [],
    sector: [],
    companies: [],
    transactionTypes: [],
    activeOrderType: {},

    profileList: [],
    createProfile: [],
    deleteProfile: [],
    search: {},
    profileDetails: [],
    allOrder: [],
    placeOrder: [],
    cancelOrder: {},
    mfColumnDef: [],
    // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - Start
    mandate: [],
    placeMandate: []
    // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - End
};


const mutualFundReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case MUTUAL_FUNDS.UPDATE_MUTUAL_FUND_WATCHLIST:
            return {
                ...state,
                watchList: actions.payload
            };
        case MUTUAL_FUNDS.GET_MUTUALFUND:
            return {
                ...state,
                mutualFund: [{
                    id: 1,
                    fundName: "ICICI Prudential Balanced Advantages Fund",
                    cagr: "23%",
                    risk: "High",
                    minimumInvestment: "5000",
                    fundManager: "Akshay Godse ( Jan 2013 - Present )",
                    minAmount: "5000",
                    nav: "274.4450",
                    image: "img1",
                    unit: "0.8855",
                    category: ['Equity', 'Large Cap'],
                    aum: "3,891. Cr.",
                    expenseRatio: "1%",
                    exitLoad: "0.5%",
                    lockInPriod: "1 year",
                    amcName: "ICICI Asset Management Pvt. Ltd.",
                    schemeName: "ICICI Produntial Balanced Advatage Fund",
                    exchangeSchemeCode: "AXISNF-GF",
                    schemeCategory: "EQUITY",
                    faceValue: "10",
                    transactionTypeAllowed: "Buy, Redeem, SIP, STP",
                    schemeLaunchDate: "28/07/2020",
                    holdings: { largeCap: "68%", midCap: "23%", smallCap: "11%" },
                    sector: [{
                        banks: "82.56%", finance: "17.44%", itSoftware: "82.56%", insurance: "17.44%", automobile: "82.56%"
                    }],
                    companies: [{
                        hdfcBank: "10.44%", axisBank: "7.51%", laursen_and_turbro: "7.51%", infosys: "7.51%", bajajFinance: "7.51%", tcs: "7.51%"
                    }]

                }, {
                    id: 2,
                    fundName: "Kotak Balanced Advantage Fund",
                    cagr: "16%",
                    risk: "High",
                    minimumInvestment: "5000",
                    fundManager: "Akshay Godse ( Jan 2013 - Present )",
                    minAmount: "500",
                    nav: "274.4450",
                    image: "img2",
                    unit: "0.8855",
                    category: ['Equity', 'Large Cap', 'Growth'],
                    aum: "3,891. Cr.",
                    expenseRatio: "1%",
                    exitLoad: "0.5%",
                    lockInPriod: "1 year",
                    amcName: "ICICI Asset Management Pvt. Ltd.",
                    schemeName: "ICICI Produntial Balanced Advatage Fund",
                    exchangeSchemeCode: "AXISNF-GF",
                    schemeCategory: "EQUITY",
                    faceValue: "10",
                    transactionTypeAllowed: "Buy, Redeem, SIP, STP",
                    schemeLaunchDate: "28/07/2020",
                    holdings: { largeCap: "18%", midCap: "23%", smallCap: "11%" },
                    sector: [{
                        banks: "82.56%", finance: "17.44%", itSoftware: "82.56%", insurance: "17.44%", automobile: "82.56%"
                    }],
                    companies: [{
                        hdfcBank: "10.44%", axisBank: "7.51%", laursen_and_turbro: "7.51%", infosys: "7.51%", bajajFinance: "7.51%", tcs: "7.51%"
                    }]
                }, {
                    id: 3,
                    fundName: "Kotak Balanced Advantage Fund",
                    risk: "High",
                    minimumInvestment: "5000",
                    fundManager: "Akshay Godse ( Jan 2013 - Present )",
                    cagr: "16%",
                    minAmount: "5000",
                    nav: "274.4450",
                    image: "img3",
                    unit: "0.8855",
                    category: ['Equity', 'Large Cap', 'Growth'],
                    aum: "3,891. Cr.",
                    expenseRatio: "1%",
                    exitLoad: "0.5%",
                    lockInPriod: "1 year",
                    amcName: "ICICI Asset Management Pvt. Ltd.",
                    schemeName: "ICICI Produntial Balanced Advatage Fund",
                    exchangeSchemeCode: "AXISNF-GF",
                    schemeCategory: "EQUITY",
                    faceValue: "10",
                    transactionTypeAllowed: "Buy, Redeem, SIP, STP",
                    schemeLaunchDate: "28/07/2020",
                    holdings: { largeCap: "55%", midCap: "20%", smallCap: "11%" },
                    sector: [{
                        banks: "82.56%", finance: "17.44%", itSoftware: "82.56%", insurance: "17.44%", automobile: "82.56%"
                    }],
                    companies: [{
                        hdfcBank: "10.44%", axisBank: "7.51%", laursen_and_turbro: "7.51%", infosys: "7.51%", bajajFinance: "7.51%", tcs: "7.51%"
                    }]
                }]




            };

        // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - Start
        case MUTUAL_FUNDS.GET_NFO_SUCCESS:
            return {
                ...state,
                nfo: actions.payload
            };

        case MUTUAL_FUNDS.GET_NFO_FAILURE:
            return {
                ...state,
                nfo: actions.payload
            };
       // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - End
        
        case MUTUAL_FUNDS.GET_THEMES:
            return {
                ...state,
                themes: [{
                    id: 1,
                    fundName: "Tax Saving Fund",

                    Description: "Lorem ipsum dolor sit amet",


                }, {
                    id: 2,
                    fundName: "Balanced Funds",

                    Description: "Lorem ipsum dolor sit amet",

                }, {
                    id: 3,
                    fundName: "Wealth Creation",

                    Description: "Lorem ipsum dolor sit amet",

                },
                {
                    id: 3,
                    fundName: "Retirement Funds",

                    Description: "Lorem ipsum dolor sit amet",

                }],
            };
        case MUTUAL_FUNDS.GET_ORDERS:
            return {
                ...state,
                orders: [{
                    first: "",
                    id: 1,
                    dateTime: '16th Jan 23 18:13:00',
                    companyName: "ICICI Prudential Balanced Advantages Fund",
                    cagr: "23%",
                    amount: "5000",
                    nav: "4534556",
                    unit: '0.0000',
                    frequency: "-",
                    type: 'BUY',
                    status: 'Completed',
                    category: ['Equity', 'Large Cap', 'Growth'],
                    details: {
                        switchFrom: "Kotak Large Cap Equity",
                        switchTo: "ICICI Prudential Balanced Advantages Fund",
                        dateTime: "16th Jan 23 18:13:00",
                        modifiedFrom: "BREEZE_TABLET",
                        exchangeOrderNo: 659436593702,
                        preOrder: "",
                        rejectionReason: "",
                        cancelOnLogout: "",
                        initiatedFrom: "BREEZE_TABLET",
                        lastUpdatedTime: "10.20 AM",
                        nextTransaction: "5th Mar 23",
                        lastTransaction: "5th Feb 23",
                        installmentCompleted: 3,
                        installmentFailed: 1,
                        installmentRemaining: 'Indefinite'
                    },
                    orderHistory: [{
                        date: "5th Feb 23",
                        amount: "3000.00",
                        status: "Partially Completed",
                        units: '29.15'
                    }, {
                        date: "5th Feb 23",
                        amount: "3000.00",
                        status: "Completed",
                        units: '29.15'
                    }, {
                        date: "5th Feb 23",
                        amount: "3000.00",
                        status: "Rejected",
                        units: '29.15'

                    }]
                },
                {
                    first: "",
                    id: 2,
                    dateTime: '16th Jan 23 18:13:00',
                    companyName: "Aditya Birla Sun Life Balanced Advantage Fund",
                    cagr: "23%",
                    amount: "7000",
                    nav: "1234556",
                    unit: '0.0000',
                    type: 'REDEEM',
                    status: 'Open',
                    frequency: "Monthly",
                    category: ['Equity', 'Large Cap', 'Growth'],
                    details: {
                        switchFrom: "Kotak Large Cap Equity",
                        switchTo: "ICICI Prudential Balanced Advantages Fund",
                        dateTime: "16th Jan 23 18:13:00",
                        modifiedFrom: "BREEZE_TABLET",
                        exchangeOrderNo: 659436593702,
                        preOrder: "",
                        rejectionReason: "",
                        cancelOnLogout: "",
                        initiatedFrom: "BREEZE_TABLET",
                        lastUpdatedTime: "10.20 AM",
                        nextTransaction: "5th Mar 23",
                        lastTransaction: "5th Feb 23",
                        installmentCompleted: 3,
                        installmentFailed: 1,
                        installmentRemaining: 'Indefinite'
                    },
                    orderHistory: [{
                        date: "5th Feb 23",
                        amount: "3000.00",
                        status: "Completed",
                        units: '29.15'
                    }]
                },
                {
                    first: "",
                    id: 2,
                    dateTime: '16th Jan 23 18:13:00',
                    companyName: "Kotak Balanced Advantage Fund",
                    frequency: "Weekly",
                    cagr: "23%",
                    amount: "7000",
                    nav: "1234556",
                    unit: '0.0000',
                    type: 'REDEEM',
                    status: 'Open',
                    category: ['Equity', 'Large Cap', 'Growth'],
                    details: {
                        switchFrom: "Kotak Large Cap Equity",
                        switchTo: "ICICI Prudential Balanced Advantages Fund",
                        dateTime: "16th Jan 23 18:13:00",
                        modifiedFrom: "BREEZE_TABLET",
                        exchangeOrderNo: 659436593702,
                        preOrder: "",
                        rejectionReason: "",
                        cancelOnLogout: "",
                        initiatedFrom: "BREEZE_TABLET",
                        lastUpdatedTime: "10.20 AM",
                        nextTransaction: "5th Mar 23",
                        lastTransaction: "5th Feb 23",
                        installmentCompleted: 3,
                        installmentFailed: 1,
                        installmentRemaining: 'Indefinite'
                    },
                    orderHistory: [{
                        date: "5th Feb 23",
                        amount: "3000.00",
                        status: "Rejected",
                        units: '29.15'
                    }]
                }, {
                    first: "",
                    id: 2,
                    dateTime: '16th Jan 23 18:13:00',
                    companyName: "Aditya Birla Sun Life Balanced Advantage Fund",
                    cagr: "23%",
                    amount: "7000",
                    nav: "1234556",
                    unit: '0.0000',
                    type: 'REDEEM',
                    status: 'Completed',
                    category: ['Equity', 'Large Cap', 'Growth'],
                    details: {
                        switchFrom: "Kotak Large Cap Equity",
                        switchTo: "ICICI Prudential Balanced Advantages Fund",
                        dateTime: "16th Jan 23 18:13:00",
                        modifiedFrom: "BREEZE_TABLET",
                        exchangeOrderNo: 659436593702,
                        preOrder: "",
                        rejectionReason: "",
                        cancelOnLogout: "",
                        initiatedFrom: "BREEZE_TABLET",
                        lastUpdatedTime: "10.20 AM",
                        nextTransaction: "5th Mar 23",
                        lastTransaction: "5th Feb 23",
                        installmentCompleted: 3,
                        installmentFailed: 1,
                        installmentRemaining: 'Indefinite'
                    },
                    orderHistory: [{
                        date: "5th Feb 23",
                        amount: "3000.00",
                        status: "Partially Completed",
                        units: '29.15'
                    }]
                }, {
                    first: "",
                    id: 2,
                    dateTime: '16th Jan 23 18:13:00',
                    companyName: "Aditya Birla Sun Life Balanced Advantage Fund",
                    cagr: "23%",
                    amount: "7000",
                    nav: "1234556",
                    unit: '0.0000',
                    type: 'REDEEM',
                    status: 'Completed',
                    category: ['Equity', 'Large Cap', 'Growth'],
                    details: {
                        switchFrom: "Kotak Large Cap Equity",
                        switchTo: "ICICI Prudential Balanced Advantages Fund",
                        dateTime: "16th Jan 23 18:13:00",
                        modifiedFrom: "BREEZE_TABLET",
                        exchangeOrderNo: 659436593702,
                        preOrder: "",
                        rejectionReason: "",
                        cancelOnLogout: "",
                        initiatedFrom: "BREEZE_TABLET",
                        lastUpdatedTime: "10.20 AM",
                        nextTransaction: "5th Mar 23",
                        lastTransaction: "5th Feb 23",
                        installmentCompleted: 3,
                        installmentFailed: 1,
                        installmentRemaining: 'Indefinite'
                    },
                    orderHistory: [{
                        date: "5th Feb 23",
                        amount: "3000.00",
                        status: "Partially Completed",
                        units: '29.15'
                    }]
                }]
            };

        case MUTUAL_FUNDS.GET_MUTUAL_FUND_WATCHLIST:
            return {
                ...state,
                watchList: actions.payload
            };
        case MUTUAL_FUNDS.GET_WACHLIST:
            return {
                ...state,
                watchList: actions.payload,
            };

        case MUTUAL_FUNDS.GET_FILTERS:
            return {
                ...state,
                filters: [
                    {
                        title: "AMC",
                        path: "/amc",
                        icon: "icon",
                        iconClosed: "",
                        iconOpen: "",

                        subNav: [{
                            title: "Axis Mutual Fund",
                            path: "/amc/axisMutualFund",
                            icon: "icon",
                        }, {
                            title: "Bank Of India Mutual Fund",
                            path: "/amc/bankOfIndiaMutualFund",
                            icon: "icon",
                        },
                        {
                            title: "Baroda BNP Paribas Mutual Fund",
                            path: "/amc/dummy2",
                            icon: "icon",
                        },
                        {
                            title: "Birla Sun Life Mutual Fund",
                            path: "/amc/dummy2",
                            icon: "icon",
                        }
                        ],

                    },
                    {
                        title: "Category",
                        path: "/Category",
                        icon: "icon",
                        iconClosed: "",
                        iconOpen: "",

                        subNav: [{
                            title: "dummy",
                            path: "/Category/dummy1",
                            icon: "icon",
                        }, {
                            title: "Filters",
                            path: "/Category/dummy2",
                            icon: "icon",
                        }],

                    },
                    {
                        title: "Sub Category",
                        path: "/amc",
                        icon: "icon",
                        iconClosed: "",
                        iconOpen: "",

                        subNav: [{
                            title: "Large Cap",
                            path: "/amc/dummy1",
                            icon: "icon",
                        }, {
                            title: "Small Cap",
                            path: "/amc/dummy2",
                            icon: "icon",
                        }, {
                            title: "Mid Cap",
                            path: "/amc/dummy2",
                            icon: "icon",
                        }, {
                            title: "ELSS",
                            path: "/amc/dummy2",
                            icon: "icon",
                        },
                        {
                            title: "Balanced",
                            path: "/amc/dummy2",
                            icon: "icon",
                        }
                        ],

                    },
                    {
                        title: "Devide Type",
                        path: "/amc",
                        icon: "icon",
                        iconClosed: "",
                        iconOpen: "",

                        subNav: [{
                            title: "dummy",
                            path: "/amc/dummy1",
                            icon: "icon",
                        }, {
                            title: "Filters",
                            path: "/amc/dummy2",
                            icon: "icon",
                        }],

                    },
                    {
                        title: "Returns",
                        path: "/amc",
                        icon: "icon",
                        iconClosed: "",
                        iconOpen: "",

                        subNav: [{
                            title: "dummy",
                            path: "/amc/dummy1",
                            icon: "icon",
                        }, {
                            title: "Filters",
                            path: "/amc/dummy2",
                            icon: "icon",
                        }],

                    },
                    {
                        title: "Exit Load",
                        path: "/amc",
                        icon: "icon",
                        iconClosed: "",
                        iconOpen: "",

                        subNav: [{
                            title: "dummy",
                            path: "/amc/dummy1",
                            icon: "icon",
                        }, {
                            title: "Filters",
                            path: "/amc/dummy2",
                            icon: "icon",
                        }],

                    },
                    {
                        title: "Min. purchase amount",
                        path: "/amc",
                        icon: "icon",
                        iconClosed: "",
                        iconOpen: "",

                        subNav: [{
                            title: "dummy",
                            path: "/amc/dummy1",
                            icon: "icon",
                        }, {
                            title: "Filters",
                            path: "/amc/dummy2",
                            icon: "icon",
                        }],

                    },
                    {
                        title: "Expense Ratio",
                        path: "/amc",
                        icon: "icon",
                        iconClosed: "",
                        iconOpen: "",

                        subNav: [{
                            title: "dummy",
                            path: "/amc/dummy1",
                            icon: "icon",
                        }, {
                            title: "Filters",
                            path: "/amc/dummy2",
                            icon: "icon",
                        }],

                    },
                    {
                        title: "AUM",
                        path: "/amc",
                        icon: "icon",
                        iconClosed: "",
                        iconOpen: "",

                        subNav: [{
                            title: "dummy",
                            path: "/amc/dummy1",
                            icon: "icon",
                        }, {
                            title: "Filters",
                            path: "/amc/dummy2",
                            icon: "icon",
                        }],

                    },
                    {
                        title: "CAGR",
                        path: "/amc",
                        icon: "icon",
                        iconClosed: "",
                        iconOpen: "",

                        subNav: [{
                            title: "dummy",
                            path: "/amc/dummy1",
                            icon: "icon",
                        }, {
                            title: "Filters",
                            path: "/amc/dummy2",
                            icon: "icon",
                        }],

                    },
                    {
                        title: "Risk",
                        path: "/amc",
                        icon: "icon",
                        iconClosed: "",
                        iconOpen: "",

                        subNav: [{
                            title: "dummy",
                            path: "/amc/dummy1",
                            icon: "icon",
                        }, {
                            title: "Filters",
                            path: "/amc/dummy2",
                            icon: "icon",
                        }],

                    },
                    {
                        title: "Lock in",
                        path: "/amc",
                        icon: "icon",
                        iconClosed: "",
                        iconOpen: "",

                        subNav: [{
                            title: "dummy",
                            path: "/amc/dummy1",
                            icon: "icon",
                        }, {
                            title: "Filters",
                            path: "/amc/dummy2",
                            icon: "icon",
                        }],

                    }
                ]
            };

        // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - Start
        case MUTUAL_FUNDS.GET_MUTUALFUND_HOLDINGS_SUCCESS:
            return {
                ...state,
                holdings: actions.payload
            }

        case MUTUAL_FUNDS.GET_MUTUALFUND_HOLDINGS_FAILURE:
            return {
                ...state,
                holdings: actions.payload
            }
        // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - Ends

        case MUTUAL_FUNDS.GET_FUND_OVERVIEW:
            return {
                ...state,
                fundOverview: [
                    {
                        companyName: "ICICI Prudential Balanced Advantage Fund",
                        fundCategory: ["Equity", "Growth"],
                        CAGR: "23% (3Y)",
                        minimumInvestment: "5000",
                        aum: "3,891. Cr.",
                        expenseRatio: "1%",
                        exitLoad: "0.5%",
                        lockInPriod: "1 year",
                        amcName: "ICICI Asset Management Pvt. Ltd.",
                        schemeName: "ICICI Produntial Balanced Advatage Fund",
                        exchangeSchemeCode: "AXISNF-GF",
                        schemeCategory: "EQUITY",
                        faceValue: "10",
                        transactionTypeAllowed: "Buy, Redeem, SIP, STP",
                        schemeLaunchDate: "28/07/2020",
                        nav: "274.4450"

                    }
                ],
                sector: [{
                    banks: "82.56%", finance: "17.44%", itSoftware: "82.56%", insurance: "17.44%", automobile: "82.56%"
                }],
                companies: [{
                    hdfcBank: "10.44%", axisBank: "7.51%", laursen_and_turbro: "7.51%", infosys: "7.51%", bajajFinance: "7.51%", tcs: "7.51%"
                }]
            };

        // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - Start
        // TODO: Remove once data structure is verified for mutual funds portfolio summary
        case MUTUAL_FUNDS.GET_SUMMARY:
            return {
                ...state,
                portfolioSumaary: [{
                    current_value: '1,40,765.82',
                    profit_loss: '(4.05%) +2,061.2',
                    today_p_l: '+50.82(2.45%)',
                    total_invested: '140000.00'
                }]
            };

        case MUTUAL_FUNDS.GET_MUTUALFUND_SUMMARY_SUCCESS:
            return {
                ...state,
                portfolioSumaary: actions.payload
            }

        case MUTUAL_FUNDS.GET_MUTUALFUND_SUMMARY_FAILURE:
            return {
                ...state,
                portfolioSumaary: actions.payload
            }
        // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - End
            
        case MUTUAL_FUNDS.GET_TRANSACTION_TYPES:
            return {
                ...state,
                transactionTypes: ['Physical', 'Online']
            };

        case MUTUAL_FUNDS.GET_ORDER_TYPES:
            return {
                ...state,
                orderTypes: [
                    {
                        id: 1,
                        name: "Orders",
                        tabKey: 'orders',
                        data: [],
                        count: 2
                    },
                    {
                        id: 2,
                        name: "SIP Instructions",
                        tabKey: 'sip_instructions',
                        data: [],
                        count: 0
                    },

                ],
                activeOrderType: {
                    id: 1,
                    name: "Orders",
                    tabKey: 'orders',
                    data: [],
                }
            };

        case MUTUAL_FUNDS.UPDATE_ACTIVE_ORDER: {
            return {
                ...state,
                activeOrderType: actions.payload
            };
        }
        case MUTUAL_FUNDS.CREATE_MUTUALFUND_PROFILE_SUCCESS: {
            return {
                ...state,
                createProfile: actions.payload
            }
        }
        case MUTUAL_FUNDS.CREATE_MUTUALFUND_PROFILE_FAILURE: {
            return {
                ...state,
                createProfile: actions
            }
        }
        case MUTUAL_FUNDS.GET_MUTUALFUND_PROFILE_LIST_SUCCESS: {
            return {
                ...state,
                profileList: actions.payload
            }
        }
        case MUTUAL_FUNDS.GET_MUTUALFUND_PROFILE_LIST_FAILURE: {
            return {
                ...state,
                profileList: actions
            }
        }
        case MUTUAL_FUNDS.DELETE_MUTUALFUND_PROFILE_SUCCESS: {
            return {
                ...state,
                deleteProfile: actions.payload
            }
        }
        case MUTUAL_FUNDS.DELETE_MUTUALFUND_PROFILE_FAILURE: {
            return {
                ...state,
                deleteProfile: actions
            }
        }
        case MUTUAL_FUNDS.GET_MUTUALFUND_SEARCH_SUCCESS: {
            return {
                ...state,
                search: actions.payload
            }
        }
        case MUTUAL_FUNDS.GET_MUTUALFUND_SEARCH_FAILURE: {
            return {
                ...state,
                search: actions
            }
        }

        case MUTUAL_FUNDS.GET_MUTUALFUND_ALL_ORDERS_SUCCESS: 
        case MUTUAL_FUNDS.GET_SYSTEMATIC_ORDERS_SUCCESS: {
            return {
                ...state,
                allOrder: actions.payload
            }
        }
        case MUTUAL_FUNDS.GET_MUTUALFUND_ALL_ORDERS_FAILURE: 
        case MUTUAL_FUNDS.GET_SYSTEMATIC_ORDERS_FAILURE: {
            return {
                ...state,
                allOrder: actions.payload
            }
        }

        // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - Start
        case MUTUAL_FUNDS.PLACE_MUTUALFUND_ORDER_SUCCESS: 
        case MUTUAL_FUNDS.PLACE_MUTUALFUND_SIP_ORDER_SUCCESS: 
        case MUTUAL_FUNDS.PLACE_MUTUALFUND_STP_ORDER_SUCCESS: 
        case MUTUAL_FUNDS.PLACE_MUTUALFUND_SWP_ORDER_SUCCESS: 
        case MUTUAL_FUNDS.PLACE_MUTUALFUND_SWITCH_ORDER_SUCCESS: {
            return {
                ...state,
                placeOrder: actions.payload
            }
        }

        case MUTUAL_FUNDS.PLACE_MUTUALFUND_ORDER_FAILURE: 
        case MUTUAL_FUNDS.PLACE_MUTUALFUND_SIP_ORDER_FAILURE: 
        case MUTUAL_FUNDS.PLACE_MUTUALFUND_STP_ORDER_FAILURE: 
        case MUTUAL_FUNDS.PLACE_MUTUALFUND_SWP_ORDER_FAILURE: 
        case MUTUAL_FUNDS.PLACE_MUTUALFUND_SWITCH_ORDER_FAILURE: {
            return {
                ...state,
                placeOrder: actions.payload
            };
        }

        case MUTUAL_FUNDS.CANCEL_MUTUALFUND_ORDER_SUCCESS:
            return {
                ...state,
                cancelOrder: actions.payload
            }

        case MUTUAL_FUNDS.CANCEL_MUTUALFUND_ORDER_FAILURE:
            return {
                ...state,
                cancelOrder: actions
            }
        // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - End

        // mf watchlist
        case MUTUAL_FUNDS.GET_MF_COLUMNDEF_SUCCESS : {
            return  {
                ...state,
                mfColumnDef : actions.payload
            }
        }

        case MUTUAL_FUNDS.GET_MF_COLUMNDEF_FAILURE : {
            return  {
                ...state,
                mfColumnDef : actions.payload
            }
        }

        // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - Start
        // Mandate
        case MUTUAL_FUNDS.GET_MANDATE_SUCCESS:
            return {
                ...state,
                mandate: actions.payload
            }

        case MUTUAL_FUNDS.GET_MANDATE_FAILURE:
            return {
                ...state,
                mandate: actions.payload
            }

        case MUTUAL_FUNDS.REGISTER_MANDATE_SUCCESS:
            return {
                ...state,
                placeMandate: actions.payload
            }

        case MUTUAL_FUNDS.REGISTER_MANDATE_FAILURE:
            return {
                ...state,
                placeMandate: actions.payload
            }
        // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - End

        default:
            return state;
    }

};

export default mutualFundReducer;